import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { FaWhatsapp } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import Eyebrow from '../../../../../../components/ui/Eyebrow';
import Price from '../../../../../../components/ui/Price';
import { moneyFormat } from '../../../../../../utils/functions';

export default function ProductItem(props) {
    const {
        image, name, id, isCustomerStoreGrid, category_name, self_reference,
        customerData, high_gold_price, price,
    } = props;

    const productImage = image ? `product-image/${id}_0.jpg` : 'general-images/product-placeholder.jpg';
    const productWhatsapp = productInterestHref(customerData, name, self_reference);
    const displayPrice = formatCardPrice(high_gold_price ?? price);

    return (
        <Grid size={styles.gridSize}>
            <Box sx={styles.container}>
                <Box sx={styles.imageContainer}>
                    <Box
                        component="img"
                        src={`https://inovartgold.com.br/assets/${productImage}`}
                        alt={name}
                        sx={styles.image}
                    />
                </Box>
                <Box sx={styles.content}>
                    <Eyebrow sx={styles.eyebrow}>
                        {[category_name || 'Joia', self_reference ? `Ref. ${self_reference}` : null]
                            .filter(Boolean)
                            .join(', ')}
                    </Eyebrow>
                    <Typography sx={styles.name}>{name}</Typography>
                    {!isCustomerStoreGrid && displayPrice && (
                        <Box sx={styles.priceBlock}>
                            <Price size="sm">{displayPrice}</Price>
                            <Typography sx={styles.priceMeta}>Ouro 18K, seu índice</Typography>
                        </Box>
                    )}
                    <Stack spacing={1} sx={{ mt: 'auto' }}>
                        {isCustomerStoreGrid ? (
                            productWhatsapp && (
                                <Button
                                    fullWidth
                                    startIcon={<FaWhatsapp size={16} />}
                                    href={productWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="contained"
                                    color="secondary"
                                >
                                    Tenho interesse
                                </Button>
                            )
                        ) : (
                            <Button
                                component={Link}
                                to={`/produto-detalhes/${id}`}
                                fullWidth
                                variant="contained"
                                color="secondary"
                            >
                                Ver detalhes
                            </Button>
                        )}
                    </Stack>
                </Box>
            </Box>
        </Grid>
    );
}

function formatCardPrice(value) {
    if (value == null || value === '' || value === 0 || value === '0') return null;
    const text = String(value).trim();
    if (text.includes('R$')) return text;
    return moneyFormat(value);
}

function productInterestHref(customerData, name, self_reference) {
    const piece = self_reference ? `${name} (Ref. ${self_reference})` : name;
    if (customerData?.whatsappHref) {
        const storeName = customerData.name;
        const message = storeName
            ? `Olá, vim pelo catálogo de ${storeName} e quero saber mais sobre ${piece}.`
            : `Olá, quero saber mais sobre ${piece}.`;
        return customerData.whatsappHref.replace(/text=[^&]*/, `text=${encodeURIComponent(message)}`);
    }
    const digits = String(customerData?.whatsapp || customerData?.whatsapp_number || '').replace(/\D/g, '');
    if (!digits) return null;
    const phone = digits.startsWith('55') ? digits : `55${digits}`;
    const message = `Olá, quero saber mais sobre ${piece}.`;
    return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
}

const styles = {
    gridSize: {
        xs: 12,
        sm: 4,
        md: 3,
    },
    container: {
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        overflow: 'hidden',
        borderRadius: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'border-color .2s',
        '&:hover': {
            borderColor: 'secondary.main',
        },
    },
    imageContainer: {
        aspectRatio: '1 / 1',
        bgcolor: 'background.paper',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        p: 2,
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    content: {
        p: 2,
        pt: 1.5,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    eyebrow: {
        mb: 0.5,
        color: 'text.secondary',
    },
    name: {
        fontFamily: 'DM Serif Display',
        fontSize: '1.15rem',
        lineHeight: 1.2,
        textAlign: 'left',
        mb: 1.25,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        minHeight: '2.4em',
    },
    priceBlock: {
        mb: 2,
    },
    priceMeta: {
        mt: 0.5,
        fontSize: '0.75rem',
        color: 'text.secondary',
        textAlign: 'left',
    },
};
